import { create } from "zustand";

const useFlightStore = create((set) => ({
    showFlightModal: false,
    setShowFlightModal: (bool) => {
        set({ showFlightModal: bool });
    },
    showBookFlightModal: false,
    setShowBookFlightModal: (bool) => {
        set({ showBookFlightModal: bool })
    },
    showBlockFlightTimeModal: false,
    setShowBlockFlightTimeModal: (bool) => {
        set({ showBlockFlightTimeModal: bool })
    }

}));

export default useFlightStore;